export const paymentMethods = [
  'CASH',
  'GOVERNMENT_HOUSING',
  'DOWN_PAYMENT_FACILITIES',
];

export const rentPaymentPeriods = [
  'MONTHLY',
  '3_MONTHS',
  '6_MONTHS',
  'YEARLY',
];

export const transactionTypes = ['RENT', 'BUY'];

export const FEATURE_OPTIONS = [
  'Balcony', 'Terrace', 'Garden', 'Parking', 'Covered Parking', 'Garage',
  'Elevator', 'Furnished', 'Unfurnished', 'Air Conditioning', 'Central Heating',
  'Swimming Pool', 'Storage', 'Laundry Room', 'Security', 'Sea View',
  'Mountain View', 'Near Public Transport', 'Near School', 'Renovated',
  'Newly Built', 'Fireplace', 'Wheelchair Accessible', 'Pets Allowed',
  'Security Camera', 'Gym', 'Playground', 'Private Entrance', 'High Floor',
  'Corner Unit', 'City View', 'Rooftop', 'Solar Panels', 'Smart Home',
];

export const LEBANON_GOVERNORATES = [
  'Beirut', 'Mount Lebanon', 'North Lebanon', 'South Lebanon',
  'Nabatieh', 'Beqaa', 'Baalbek-Hermel', 'Akkar',
];

export const DISTRICT_MAP: Record<string, string[]> = {
  Beirut: ['Beirut'],
  'Mount Lebanon': ['Baabda', 'Aley', 'Chouf', 'Keserwan', 'Jbeil', 'Matn'],
  'North Lebanon': ['Tripoli', 'Batroun', 'Bsharri', 'Koura', 'Miniyeh-Danniyeh', 'Zgharta'],
  'South Lebanon': ['Sidon', 'Tyre', 'Jezzine'],
  Nabatieh: ['Nabatieh', 'Bint Jbeil', 'Hasbaya', 'Marjeyoun'],
  Beqaa: ['Zahle', 'West Beqaa', 'Rashaya'],
  'Baalbek-Hermel': ['Baalbek', 'Hermel'],
  Akkar: ['Akkar'],
};
